export default "__VITE_ASSET__9fa4b699__"